import * as RadixDialog from '@radix-ui/react-dialog';
import styled, { css } from 'styled-components/macro';
import { menuSlideInBottom, menuSlideOutBottom } from '../menu/menu.animations';

import { overlayFadeIn, overlayFadeOut } from './dialog.animations';

export const StyledOverlay = styled(RadixDialog.Overlay)`
  ${({ theme }) => css`
    padding: 0 24px 0 56px;
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacings.base};
    background-color: rgba(0, 0, 0, 0.8);
    animation-timing-function: ${theme.tokens.animation.easing.standard};
    animation-duration: ${theme.tokens.animation.duration.short};
    overflow-y: scroll;

    &[data-state='open'] {
      animation-name: ${overlayFadeIn};
    }

    &[data-state='closed'] {
      animation-name: ${overlayFadeOut};
    }
  `}
`;

export const StyledContent = styled(RadixDialog.Content)`
  ${({ theme }) => css`
    margin-block: 120px;
    display: flex;
    justify-content: center;
    gap: ${theme.spacings.xs};
    width: fit-content;
    max-width: 90dvw;
    height: fit-content;
    opacity: 0;
    will-change: transform, opacity;
    animation-duration: ${theme.tokens.animation.duration.base};
    animation-timing-function: ${theme.tokens.animation.easing.standard};
    animation-fill-mode: forwards;
    outline: none;

    &[data-state='open'] {
      animation-name: ${menuSlideInBottom};
    }

    &[data-state='closed'] {
      animation-name: ${menuSlideOutBottom};
    }
  `}
`;

export const StyledPanel = styled.div`
  ${({ theme }) => css`
    width: 100%;
    background: ${theme.semantic.bg.surface};
    border-radius: ${theme.radiuses.base};

    &:last-child {
      margin-bottom: 120px;
    }

    ${theme.mode === 'dark' &&
    css`
      border: 1px solid ${theme.semantic.border.default};
    `}
  `}
`;

export const NavigationWrapper = styled.div`
  ${({ theme }) => css`
    margin: 16px 0 120px;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xs};
    color: ${theme.colors.white};
  `}
`;

export const StyledNavigation = styled.div`
  ${({ theme }) => css`
    position: sticky;
    top: 16px;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xxl};

    & .svg-viewer {
      width: 24px;
      height: 24px;
      cursor: pointer;
      color: #ffffff;
    }
  `}
`;

export const Arrow = styled.div<{ $isShown: boolean }>`
  ${({ $isShown }) => css`
    transform: scale(${$isShown ? 1 : 0});
    transition-duration: 200ms;
    pointer-events: auto;
  `}
`;

export const StyledTitle = styled(RadixDialog.Title)`
  ${({ theme }) => css`
    ${theme.fonts['heading-3'].css}
  `}
`;
